/** @format */

import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Button, Container, TableBody } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { InputNumber, Popover } from "antd";
import { Steps } from "antd";
import Divider from "@material-ui/core/Divider";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import NextHead from "next/head";

const { Step } = Steps;

const classes = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
});

class Pflegegradrechner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      MobilitätEins: 0,
      MobilitätZwei: 0,
      MobilitätDrei: 0,
      MobilitätVier: 0,
      MobilitätFünf: 0,
      MobilitätWert: 0,
      MobilitätGewichtet: 0,
      KognitivEins: 0,
      KognitivZwei: 0,
      KognitivDrei: 0,
      KognitivVier: 0,
      KognitivFünf: 0,
      KognitivSechs: 0,
      KognitivSieben: 0,
      KognitivAcht: 0,
      KognitivNeun: 0,
      KognitivZehn: 0,
      KognitivElf: 0,
      KognitivWert: 0,
      KognitivGewichtet: 0,
      VerhaltenEins: 0,
      VerhaltenZwei: 0,
      VerhaltenDrei: 0,
      VerhaltenVier: 0,
      VerhaltenFünf: 0,
      VerhaltenSechs: 0,
      VerhaltenSieben: 0,
      VerhaltenAcht: 0,
      VerhaltenNeun: 0,
      VerhaltenZehn: 0,
      VerhaltenElf: 0,
      VerhaltenZwölf: 0,
      VerhaltenDreizehn: 0,
      VerhaltenWert: 0,
      VerhaltenGewichtet: 0,
      VersorgungEins: 0,
      VersorgungZwei: 0,
      VersorgungDrei: 0,
      VersorgungVier: 0,
      VersorgungFünf: 0,
      VersorgungSechs: 0,
      VersorgungSieben: 0,
      VersorgungAcht: 0,
      VersorgungNeun: 0,
      VersorgungZehn: 0,
      VersorgungElf: 0,
      VersorgungZwölf: 0,
      VersorgungWert: 0,
      VersorgungGewichtet: 0,
      UmgangEins: 0,
      UmgangZwei: 0,
      UmgangDrei: 0,
      UmgangVier: 0,
      UmgangFünf: 0,
      UmgangSechs: 0,
      UmgangSieben: 0,
      UmgangAcht: 0,
      UmgangNeun: 0,
      UmgangZehn: 0,
      UmgangElf: 0,
      UmgangZwölf: 0,
      UmgangDreiZehn: 0,
      UmgangVierZehn: 0,
      UmgangFünfZehn: 0,
      UmgangSechsZehn: 0,
      UmgangWert1bis7: 0,
      UmgangGewichtet1bis7: 0,
      UmgangWert8bis11: 0,
      UmgangGewichtet8bis11: 0,
      UmgangWert12bis15: 0,
      UmgangGewichtet12bis15: 0,
      UmgangGewichtet: 0,
      UmgangEinsAnzahl: 0,
      UmgangZweiAnzahl: 0,
      UmgangDreiAnzahl: 0,
      UmgangVierAnzahl: 0,
      UmgangFünfAnzahl: 0,
      UmgangSechsAnzahl: 0,
      UmgangSiebenAnzahl: 0,
      UmgangAchtAnzahl: 0,
      UmgangNeunAnzahl: 0,
      UmgangZehnAnzahl: 0,
      UmgangElfAnzahl: 0,
      UmgangZwölfAnzahl: 0,
      UmgangDreiZehnAnzahl: 0,
      UmgangVierZehnAnzahl: 0,
      UmgangFünfZehnAnzahl: 0,
      UmgangSechsZehnAnzahl: 0,
      disabled: true,
      AlltagEins: 0,
      AlltagZwei: 0,
      AlltagDrei: 0,
      AlltagVier: 0,
      AlltagFünf: 0,
      AlltagSechs: 0,
      AlltagWert: 0,
      AlltagGewichtet: 0,
      current: 0,
    };
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleNumber = (name) => (value) => {
    this.setState({ [name]: value });
  };
  /* Auf nächste Seite navigieren */
  next = () => {
    let { current } = this.state;
    current = current + 1;
    this.setState({ current: current });
    if (window !== undefined) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }
  };
  /* eine Seite zurück navigieren */
  back = () => {
    let { current } = this.state;
    current = current - 1;
    this.setState({ current: current });
    if (window !== undefined) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }
  };
  /* Eingaben bestätigen und Pflegegrad ermitteln */
  submit = () => {
    this.next();
    let {
      MobilitätEins,
      MobilitätZwei,
      MobilitätDrei,
      MobilitätVier,
      MobilitätFünf,
      MobilitätWert,
      MobilitätGewichtet,
      KognitivEins,
      KognitivZwei,
      KognitivDrei,
      KognitivVier,
      KognitivFünf,
      KognitivSechs,
      KognitivSieben,
      KognitivAcht,
      KognitivNeun,
      KognitivZehn,
      KognitivElf,
      KognitivWert,
      KognitivGewichtet,
      VerhaltenEins,
      VerhaltenZwei,
      VerhaltenDrei,
      VerhaltenVier,
      VerhaltenFünf,
      VerhaltenSechs,
      VerhaltenSieben,
      VerhaltenAcht,
      VerhaltenNeun,
      VerhaltenZehn,
      VerhaltenElf,
      VerhaltenZwölf,
      VerhaltenDreizehn,
      VerhaltenWert,
      VerhaltenGewichtet,
      VersorgungEins,
      VersorgungZwei,
      VersorgungDrei,
      VersorgungVier,
      VersorgungFünf,
      VersorgungSechs,
      VersorgungSieben,
      VersorgungAcht,
      VersorgungNeun,
      VersorgungZehn,
      VersorgungElf,
      VersorgungZwölf,
      VersorgungWert,
      VersorgungGewichtet,
      UmgangEins,
      UmgangZwei,
      UmgangDrei,
      UmgangVier,
      UmgangFünf,
      UmgangSechs,
      UmgangSieben,
      UmgangAcht,
      UmgangNeun,
      UmgangZehn,
      UmgangElf,
      UmgangZwölf,
      UmgangDreiZehn,
      UmgangVierZehn,
      UmgangFünfZehn,
      UmgangSechsZehn,
      UmgangWert1bis7,
      UmgangGewichtet1bis7,
      UmgangWert8bis11,
      UmgangGewichtet8bis11,
      UmgangWert12bis15,
      UmgangGewichtet12bis15,
      UmgangGewichtet,
      UmgangEinsAnzahl,
      UmgangZweiAnzahl,
      UmgangDreiAnzahl,
      UmgangVierAnzahl,
      UmgangFünfAnzahl,
      UmgangSechsAnzahl,
      UmgangSiebenAnzahl,
      UmgangAchtAnzahl,
      UmgangNeunAnzahl,
      UmgangZehnAnzahl,
      UmgangElfAnzahl,
      UmgangZwölfAnzahl,
      UmgangDreiZehnAnzahl,
      UmgangVierZehnAnzahl,
      UmgangFünfZehnAnzahl,
      UmgangSechsZehnAnzahl,
      disabled,
      AlltagEins,
      AlltagZwei,
      AlltagDrei,
      AlltagVier,
      AlltagFünf,
      AlltagSechs,
      AlltagWert,
      AlltagGewichtet,
      current,
    } = this.state;

    {
      /*Mobilität Gesamtpunkte */
    }
    MobilitätWert =
      MobilitätEins +
      MobilitätZwei +
      MobilitätDrei +
      MobilitätVier +
      MobilitätFünf;

    {
      /*Mobilität Gewichtete Punkte */
    }
    if (MobilitätWert <= 1) {
      MobilitätGewichtet = 0;
    } else if (MobilitätWert <= 3) {
      MobilitätGewichtet = 2.5;
    } else if (MobilitätWert <= 5) {
      MobilitätGewichtet = 5;
    } else if (MobilitätWert <= 9) {
      MobilitätGewichtet = 7.5;
    } else {
      MobilitätGewichtet = 10;
    }

    {
      /*Kognitiv Gesamtpunkte */
    }
    KognitivWert =
      KognitivEins +
      KognitivZwei +
      KognitivDrei +
      KognitivVier +
      KognitivFünf +
      KognitivSieben +
      KognitivAcht +
      KognitivNeun +
      KognitivZehn +
      KognitivElf;

    {
      /*Kognitiv Gewichtete Punkte */
    }
    if (KognitivWert <= 1) {
      KognitivGewichtet = 0;
    } else if (KognitivWert <= 5) {
      KognitivGewichtet = 3.75;
    } else if (KognitivWert <= 10) {
      KognitivGewichtet = 7.5;
    } else if (KognitivWert <= 16) {
      KognitivGewichtet = 11.25;
    } else {
      KognitivGewichtet = 15;
    }

    {
      /*Verhalten Gesamtpunkte */
    }
    VerhaltenWert =
      VerhaltenEins +
      VerhaltenZwei +
      VerhaltenDrei +
      VerhaltenVier +
      VerhaltenFünf +
      VerhaltenSechs +
      VerhaltenSieben +
      VerhaltenAcht +
      VerhaltenNeun +
      VerhaltenZehn +
      VerhaltenElf +
      VerhaltenZwölf +
      VerhaltenDreizehn;

    {
      /*Vehrhalten Gewichtete Punkte */
    }
    if (VerhaltenWert === 0) {
      VerhaltenGewichtet = 0;
    } else if (VerhaltenWert <= 2) {
      VerhaltenGewichtet = 3.75;
    } else if (VerhaltenWert <= 4) {
      VerhaltenGewichtet = 7.5;
    } else if (VerhaltenWert <= 6) {
      VerhaltenGewichtet = 11.25;
    } else {
      VerhaltenGewichtet = 15;
    }

    {
      /*Versorgung Gesamtpunkte */
    }
    VersorgungWert =
      VersorgungEins +
      VersorgungZwei +
      VersorgungDrei +
      VersorgungVier +
      VersorgungFünf +
      VersorgungSechs +
      VersorgungSieben +
      VersorgungAcht +
      VersorgungNeun +
      VersorgungZehn +
      VersorgungElf +
      VersorgungZwölf;

    {
      /*Versorgung Gewichtete Punkte */
    }
    if (VersorgungWert <= 2) {
      VersorgungGewichtet = 0;
    } else if (VersorgungWert <= 7) {
      VersorgungGewichtet = 10;
    } else if (VersorgungWert <= 18) {
      VersorgungGewichtet = 20;
    } else if (VersorgungWert <= 36) {
      VersorgungGewichtet = 30;
    } else {
      VersorgungGewichtet = 40;
    }

    //let Anzahl = 0
    {
      /*Umgang Umrechnung pro Tag Frage 5.1-5.7 */
    }
    if (UmgangEins === 2) {
      UmgangEinsAnzahl = UmgangEinsAnzahl / 7;
    } else if (UmgangEins === 3) {
      UmgangEinsAnzahl = UmgangEinsAnzahl / 30;
    }

    if (UmgangZwei === 2) {
      UmgangZweiAnzahl = UmgangZweiAnzahl / 7;
    } else if (UmgangZwei === 3) {
      UmgangZweiAnzahl = UmgangZweiAnzahl / 30;
    }

    if (UmgangDrei === 2) {
      UmgangDreiAnzahl = UmgangDreiAnzahl / 7;
    } else if (UmgangDrei === 3) {
      UmgangDreiAnzahl = UmgangDreiAnzahl / 30;
    }

    if (UmgangVier === 2) {
      UmgangVierAnzahl = UmgangVierAnzahl / 7;
    } else if (UmgangVier === 3) {
      UmgangVierAnzahl = UmgangVierAnzahl / 30;
    }

    if (UmgangFünf === 2) {
      UmgangFünfAnzahl = UmgangFünfAnzahl / 7;
    } else if (UmgangFünf === 3) {
      UmgangFünfAnzahl = UmgangFünfAnzahl / 30;
    }

    if (UmgangSechs === 2) {
      UmgangSechsAnzahl = UmgangSechsAnzahl / 7;
    } else if (UmgangSechs === 3) {
      UmgangSechsAnzahl = UmgangSechsAnzahl / 30;
    }

    if (UmgangSieben === 2) {
      UmgangSiebenAnzahl = UmgangSiebenAnzahl / 7;
    } else if (UmgangSieben === 3) {
      UmgangSiebenAnzahl = UmgangSiebenAnzahl / 30;
    }

    {
      /*Umgang Frage 5.1-5.7 Gesamstpunkte */
    }
    UmgangWert1bis7 =
      UmgangEinsAnzahl +
      UmgangZweiAnzahl +
      UmgangDreiAnzahl +
      UmgangVierAnzahl +
      UmgangFünfAnzahl +
      UmgangSechsAnzahl +
      UmgangSiebenAnzahl;

    {
      /*Umgang Gewichtung Frage 5.1-5.7 */
    }
    if (UmgangWert1bis7 <= 1) {
      UmgangGewichtet1bis7 = 0;
    } else if (UmgangWert1bis7 <= 3) {
      UmgangGewichtet1bis7 = 1;
    } else if (UmgangWert1bis7 <= 8) {
      UmgangGewichtet1bis7 = 2;
    } else {
      UmgangGewichtet1bis7 = 3;
    }

    {
      /*Umgang Umrechnung Frage 5.8-5.11 */
    }
    if (UmgangAcht === 2) {
      UmgangAchtAnzahl = UmgangAchtAnzahl / 7;
    } else if (UmgangAcht === 3) {
      UmgangAchtAnzahl = UmgangAchtAnzahl / 30;
    }

    if (UmgangNeun === 2) {
      UmgangNeunAnzahl = UmgangNeunAnzahl / 7;
    } else if (UmgangNeun === 3) {
      UmgangNeunAnzahl = UmgangNeunAnzahl / 30;
    }

    if (UmgangZehn === 2) {
      UmgangZehnAnzahl = UmgangZehnAnzahl / 7;
    } else if (UmgangAcht === 3) {
      UmgangZehnAnzahl = UmgangZehnAnzahl / 30;
    }

    if (UmgangElf === 2) {
      UmgangElfAnzahl = UmgangElfAnzahl / 7;
    } else if (UmgangAcht === 3) {
      UmgangElfAnzahl = UmgangElfAnzahl / 30;
    }

    {
      /*Umgang Frage 5.8-5.11 Gesamtpunkte */
    }
    UmgangWert8bis11 =
      UmgangAchtAnzahl + UmgangNeunAnzahl + UmgangZehnAnzahl + UmgangElfAnzahl;
    //let UmgangVarWöchentlich = UmgangWert8bis11 * 7

    {
      /*Umgang Frage 5.8-5.11 Gewichtung */
    }
    if (UmgangWert8bis11 < 1) {
      UmgangGewichtet8bis11 = 0;
    } else if (UmgangWert8bis11 > 1) {
      UmgangGewichtet8bis11 = 1;
    }

    if (UmgangWert8bis11 <= 2 && UmgangWert8bis11 > 1) {
      UmgangGewichtet8bis11 = 2;
    } else {
      UmgangGewichtet8bis11 = 3;
    }

    {
      /*Umgang Umrechnung Frage 5.12-5.15 */
    }
    if (UmgangZwölf === 1) {
      UmgangWert12bis15 = UmgangWert12bis15 + 60;
    } else if (UmgangZwölf === 2) {
      UmgangWert12bis15 = UmgangWert12bis15 + 8.6;
    } else if (UmgangZwölf === 3) {
      UmgangWert12bis15 = UmgangWert12bis15 + 2;
    }

    if (UmgangDreiZehn === 2) {
      UmgangWert12bis15 = UmgangWert12bis15 + UmgangDreiZehnAnzahl * 4.3;
    } else if (UmgangDreiZehn === 3) {
      UmgangWert12bis15 = UmgangWert12bis15 + UmgangDreiZehnAnzahl;
    }

    if (UmgangVierZehn === 2) {
      UmgangWert12bis15 = UmgangWert12bis15 + UmgangVierZehnAnzahl * 4.3;
    } else if (UmgangVierZehn === 3) {
      UmgangWert12bis15 = UmgangWert12bis15 + UmgangVierZehnAnzahl;
    }

    if (UmgangFünfZehn === 2) {
      UmgangWert12bis15 = UmgangWert12bis15 + UmgangFünfZehnAnzahl * 4.3;
    } else if (UmgangVierZehn === 3) {
      UmgangWert12bis15 = UmgangWert12bis15 + UmgangFünfZehnAnzahl;
    }

    {
      /*Umgang Gewichtet Frage 5.12-5.15 */
    }
    if (UmgangWert12bis15 < 4.3) {
      UmgangGewichtet12bis15 = 0;
    } else if (UmgangWert12bis15 < 8.5) {
      UmgangGewichtet12bis15 = 1;
    } else if (UmgangWert12bis15 < 12.8) {
      UmgangGewichtet12bis15 = 2;
    } else if (UmgangWert12bis15 < 60) {
      UmgangGewichtet12bis15 = 3;
    } else {
      UmgangGewichtet12bis15 = 6;
    }

    let ZwischensummeUmgang =
      UmgangGewichtet1bis7 +
      UmgangGewichtet8bis11 +
      UmgangGewichtet12bis15 +
      UmgangSechsZehn;

    {
      /*Umgang Gewichtete Punkte */
    }
    if (ZwischensummeUmgang === 0) {
      UmgangGewichtet = 0;
    } else if (ZwischensummeUmgang === 1) {
      UmgangGewichtet = 5;
    } else if (ZwischensummeUmgang <= 3) {
      UmgangGewichtet = 10;
    } else if (ZwischensummeUmgang <= 5) {
      UmgangGewichtet = 15;
    } else {
      UmgangGewichtet = 20;
    }

    {
      /*Alltag Gesamtpunkte */
    }
    AlltagWert =
      AlltagEins +
      AlltagZwei +
      AlltagDrei +
      AlltagVier +
      AlltagFünf +
      AlltagSechs;

    {
      /*Alltag Gewichtete Punkte */
    }
    if (AlltagWert === 0) {
      AlltagGewichtet = 0;
    } else if (AlltagWert <= 3) {
      AlltagGewichtet = 3.75;
    } else if (AlltagWert <= 6) {
      AlltagGewichtet = 7.5;
    } else if (AlltagWert <= 11) {
      AlltagGewichtet = 11.25;
    } else {
      AlltagGewichtet = 15;
    }

    {
      /*Punkte gesamt berechnen */
    }
    let PunkteGesamt =
      MobilitätGewichtet +
      VersorgungGewichtet +
      UmgangGewichtet +
      AlltagGewichtet;

    {
      /*Modul 2 oder 3, höheres */
    }
    if (KognitivGewichtet > VerhaltenGewichtet) {
      PunkteGesamt = PunkteGesamt + KognitivGewichtet;
    } else {
      PunkteGesamt = PunkteGesamt + VerhaltenGewichtet;
    }

    {
      /*Pflegegrad berechnen */
    }
    let Pflegegrad = 0;

    if (PunkteGesamt < 12.5) {
      Pflegegrad = 0;
    } else if (PunkteGesamt >= 12.5 && PunkteGesamt < 27) {
      Pflegegrad = 1;
    } else if (PunkteGesamt >= 27 && PunkteGesamt < 47.5) {
      Pflegegrad = 2;
    } else if (PunkteGesamt >= 47.5 && PunkteGesamt < 70) {
      Pflegegrad = 3;
    } else if (PunkteGesamt >= 70 && PunkteGesamt < 90) {
      Pflegegrad = 4;
    } else {
      Pflegegrad = 5;
    }

    this.setState({
      MobilitätGewichtet: MobilitätGewichtet,
      KognitivGewichtet: KognitivGewichtet,
      VerhaltenGewichtet: VerhaltenGewichtet,
      VersorgungGewichtet: VersorgungGewichtet,
      UmgangWert1bis7: UmgangWert1bis7,
      UmgangGewichtet: UmgangGewichtet1bis7,
      AlltagGewichtet: AlltagGewichtet,
      Pflegegrad: Pflegegrad,
      UmgangWert8bis11: UmgangWert8bis11,
      UmgangGewichtet8bis11: UmgangGewichtet8bis11,
    });
  };
  render() {
    const { classes } = this.props;
    const {
      MobilitätEins,
      MobilitätZwei,
      MobilitätDrei,
      MobilitätVier,
      MobilitätFünf,
      KognitivEins,
      KognitivZwei,
      KognitivDrei,
      KognitivVier,
      KognitivFünf,
      KognitivSechs,
      KognitivSieben,
      KognitivAcht,
      KognitivNeun,
      KognitivZehn,
      KognitivElf,
      VerhaltenEins,
      VerhaltenZwei,
      VerhaltenDrei,
      VerhaltenVier,
      VerhaltenFünf,
      VerhaltenSechs,
      VerhaltenSieben,
      VerhaltenAcht,
      VerhaltenNeun,
      VerhaltenZehn,
      VerhaltenElf,
      VerhaltenZwölf,
      VerhaltenDreizehn,
      VersorgungEins,
      VersorgungZwei,
      VersorgungDrei,
      VersorgungVier,
      VersorgungFünf,
      VersorgungSechs,
      VersorgungSieben,
      VersorgungAcht,
      VersorgungNeun,
      VersorgungZehn,
      VersorgungElf,
      VersorgungZwölf,
      UmgangEins,
      UmgangZwei,
      UmgangDrei,
      UmgangVier,
      UmgangFünf,
      UmgangSechs,
      UmgangSieben,
      UmgangAcht,
      UmgangNeun,
      UmgangZehn,
      UmgangElf,
      UmgangZwölf,
      UmgangDreiZehn,
      UmgangVierZehn,
      UmgangFünfZehn,
      UmgangSechsZehn,
      UmgangEinsAnzahl,
      UmgangZweiAnzahl,
      UmgangDreiAnzahl,
      UmgangVierAnzahl,
      UmgangFünfAnzahl,
      UmgangSechsAnzahl,
      UmgangSiebenAnzahl,
      UmgangAchtAnzahl,
      UmgangNeunAnzahl,
      UmgangZehnAnzahl,
      UmgangElfAnzahl,
      UmgangZwölfAnzahl,
      UmgangDreihZehnAnzahl,
      UmgangVierZehnAnzahl,
      UmgangFünfZehnAnzahl,
      UmgangSechsZehnAnzahl,
      disabled,
      AlltagEins,
      AlltagZwei,
      AlltagDrei,
      AlltagVier,
      AlltagFünf,
      AlltagSechs,
      current,
    } = this.state;
    return (
      <div>
        <NextHead>
          <meta charSet="UTF-8" />
          <title>CareNext - Pflegeplatzsuche</title>
          <meta
            name="description"
            content="Pflegegrad selbst ausrechnen - Mit unserem Pflegegradrechner finden Sie schnell heraus, welcher Pflegegrad Ihnen zusteht"
          />
          <link
            rel="canonical"
            href="https://hilfebeipflege.de/pflegegradrechner"
          />
        </NextHead>
        <br />
        <br />
        <br />
        <Container maxWidth="md">
          <Steps current={current}>
            <Step />
            <Step />
            <Step />
            <Step />
            <Step />
            <Step />
          </Steps>
          <Grid
            container
            spacing={3}
            style={{
              margin: "30px 0px",
              padding: 10,
              background: "#ffffff",
              borderRadius: 10,
            }}
          >
            {current === 0 ? (
              <>
                <h2>Mobilität</h2>
                {/*Mobilität Frage 1.1 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      1.1 Positionswechsel im Bett
                    </h4>
                    <Popover
                      content="Einnehmen von verschiedenen Positionen im Bett, Drehen um die Längsachse,
                                    Aufrichten aus dem Liegen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl
                      className={classes.formControl}
                      style={{ color: "#484848" }}
                    >
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={MobilitätEins}
                        onChange={this.handleChange}
                        name="MobilitätEins"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <Divider />

                {/*Mobilität Frage 1.2 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      1.2 Halten einer stabilen Sitzposition
                    </h4>
                    <Popover
                      content="Sich auf einem Bett, Stuhl oder Sessel aufrecht halten."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl
                      className={classes.formControl}
                      style={{ color: "#484848" }}
                    >
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={MobilitätZwei}
                        onChange={this.handleChange}
                        name="MobilitätZwei"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Mobilität Frage 1.3 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>1.3 Umsetzen</h4>
                    <Popover
                      content="Von einer erhöhten Sitzfläche, Bettkante, Stuhl, Sessel, Bank, Toilette etc., aufstehen und sich auf einen Rollstuhl, Toilettenstuhl, Sessel o.ä. umsetzen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl
                      className={classes.formControl}
                      style={{ color: "#484848" }}
                    >
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={MobilitätDrei}
                        onChange={this.handleChange}
                        name="MobilitätDrei"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Mobilität Frage 1.4 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      1.4 Fortbewegen innerhalb des Wohnbereichs
                    </h4>
                    <Popover
                      content="Sich innerhalb einer Wohnung oder im Wohnbereich einer Einrichtung zwischen
                                    den Zimmern sicher bewegen "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl
                      className={classes.formControl}
                      style={{ color: "#484848" }}
                    >
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={MobilitätVier}
                        onChange={this.handleChange}
                        name="MobilitätVier"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Mobilität Frage 1.5 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>1.5 Treppensteigen</h4>
                    <Popover
                      content="Überwinden von Treppen zwischen zwei Etagen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl
                      className={classes.formControl}
                      style={{ color: "#484848" }}
                    >
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={MobilitätFünf}
                        onChange={this.handleChange}
                        name="MobilitätFünf"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </>
            ) : current === 1 ? (
              <>
                <h2>Kognitive und kommunikative Fähigkeiten</h2>
                {/*Kognitiv Frage 2.1 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.1 Erkennen von Personen aus dem näheren Umfeld
                    </h4>
                    <Popover
                      content="Fähigkeit, Personen aus dem näheren Umfeld wiederzuerkennen, d. h. Menschen,
                                    zu denen im Alltag regelmäßig ein direkter Kontakt besteht"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivEins}
                        onChange={this.handleChange}
                        name="KognitivEins"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognivität Frage 2.2 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.2 Örtliche Orientierung
                    </h4>
                    <Popover
                      content="Fähigkeit, sich in der räumlichen Umgebung zurechtzufinden, andere Orte gezielt
                                    anzusteuern und zu wissen, wo man sich befindet"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivZwei}
                        onChange={this.handleChange}
                        name="KognitivZwei"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognivität Frage 2.3 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.3 Zeitliche Orientierung
                    </h4>
                    <Popover
                      content="Fähigkeit, zeitliche Strukturen zu erkennen. Dazu gehören Uhrzeit, Tagesabschnitte (Vormittag, Nachmittag, Abend etc.), Jahreszeiten und die zeitliche Abfolge des eigenen Lebens."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivDrei}
                        onChange={this.handleChange}
                        name="KognitivDrei"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognitivität Frage 2.4 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.4 Erinnern an wesentliche Ereignisse oder Beobachtungen
                    </h4>
                    <Popover
                      content="Fähigkeit, sich an kurz und auch länger zurückliegende Ereignisse oder Beobachtungen zu erinnern. Dazu gehört, dass die Person z. B. weiß, was sie zum Frühstück gegessen hat oder
                                    mit welchen Tätigkeiten sie den Vormittag verbracht hat."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivVier}
                        onChange={this.handleChange}
                        name="KognitivVier"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognivität Frage 2.5 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.5 Steuern von mehrschrittigen Alltagshandlungen
                    </h4>
                    <Popover
                      content="Fähigkeit, zielgerichtete Handlungen des Lebensalltags, die eine Abfolge von Teilschritten umfassen, zu steuern. Wie z. B. das komplette Ankleiden, Kaffeekochen oder Tischdecken."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivFünf}
                        onChange={this.handleChange}
                        name="KognitivFünf"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognivität Frage 2.6 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.6 Treffen von Entscheidungen im Alltag
                    </h4>
                    <Popover
                      content="Fähigkeit, folgerichtige und geeignete Entscheidungen im Alltagsleben zu treffen. Dazu gehört z. B. die dem Wetter angepasste Auswahl von Kleidung, die Entscheidung über die Durchführung von Aktivitäten wie Einkaufen, Familienangehörige oder Freunde anrufen, einer Freizeitbeschäftigung nachzugehen."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivSechs}
                        onChange={this.handleChange}
                        name="KognitivSechs"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognivität Frage 2.7 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.7 Verstehen von Sachverhalten und Informationen
                    </h4>
                    <Popover
                      content="Fähigkeit, Sachverhalte zu verstehen und Informationen inhaltlich einordnen zu
                                    können"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivSieben}
                        onChange={this.handleChange}
                        name="KognitivSieben"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognivität Frage 2.8 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.8 Erkennen von Risiken und Gefahren
                    </h4>
                    <Popover
                      content="Fähigkeit, Risiken und Gefahren zu erkennen. Dazu gehören Gefahren wie Strom- und Feuerquellen, Barrieren und Hindernisse
                                    auf dem Fußboden bzw. auf Fußwegen."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivAcht}
                        onChange={this.handleChange}
                        name="KognitivAcht"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognivität Frage 2.9 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.9 Mitteilen von elementaren Bedürfnissen
                    </h4>
                    <Popover
                      content="Fähigkeit, elementare Bedürfnisse verbal oder nonverbal mitzuteilen. Das beinhaltet sich bei Hunger oder Durst, Schmerzen oder Frieren bemerkbar zu
                                    machen."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivNeun}
                        onChange={this.handleChange}
                        name="KognitivNeun"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognivität Frage 2.10 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.10 Verstehen von Aufforderungen
                    </h4>
                    <Popover
                      content="Fähigkeit, Aufforderungen in Hinblick auf alltägliche Grundbedürfnisse zu verstehen. Zu den alltäglichen Grundbedürfnissen gehören z. B. Essen, Trinken, sich kleiden,
                                    sich beschäftigen."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivZehn}
                        onChange={this.handleChange}
                        name="KognitivZehn"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Kognivität Frage 2.11 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      2.11 Beteiligen an einem Gespräch
                    </h4>
                    <Popover
                      content="Fähigkeit, in einem Gespräch Gesprächsinhalte aufzunehmen, sinngerecht zu antworten und zur Weiterführung des Gesprächs Inhalte einzubringen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={KognitivElf}
                        onChange={this.handleChange}
                        name="KognitivElf"
                      >
                        <MenuItem key={0} value={0}>
                          Fähgikeiten vorhanden
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          Fähigkeiten größtenteils vorhanden
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          Fährigkeiten in geringem Maße vorhanden
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Fähgikeiten nicht vorhanden
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </>
            ) : current === 2 ? (
              <>
                <h2>Verhaltensweisen und psychische Problemlagen</h2>
                {/*Verhalten Frage 3.1 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      3.1 Motorisch geprägte Verhaltensauffälligkeiten
                    </h4>
                    <Popover
                      content="Dazu gehören
                                    vor allem das (scheinbar) ziellose Umhergehen in der Wohnung oder der Einrichtung und der Versuch desorientierter Personen, ohne Begleitung die Wohnung, Einrichtung zu verlassen oder Orte aufzusuchen, die für diese Person unzugänglich sein
                                    sollten, z. B. Treppenhaus, Zimmer anderer Bewohner."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenEins}
                        onChange={this.handleChange}
                        name="VerhaltenEins"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.2 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>3.2 Nächtliche Unruhe</h4>
                    <Popover
                      content="Gemeint sind hier nächtliches Umherirren oder nächtliche Unruhephasen bis hin
                                    zur Umkehr des Tag-, Nachtrhythmus im Sinne von aktiv sein in der Nacht und schlafen während des Tages"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenZwei}
                        onChange={this.handleChange}
                        name="VerhaltenZwei"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.3 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      3.3 Selbstschädigendes und autoagressives Verhalten
                    </h4>
                    <Popover
                      content="Selbstschädigendes und autoaggressives Verhalten kann z. B. darin bestehen, sich
                                    selbst durch Gegenstände zu verletzen, ungenießbare Substanzen zu essen und zu
                                    trinken, sich selbst schlagen und sich selbst mit den Fingernägeln oder Zähnen verletzen. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenDrei}
                        onChange={this.handleChange}
                        name="VerhaltenDrei"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.4 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      3.4 Beschädigen von Gegenständen
                    </h4>
                    <Popover
                      content="Gemeint sind hier aggressive, auf Gegenstände gerichtete Handlungen wie Gegenstände wegstoßen oder wegschieben, gegen Gegenstände schlagen, das Zerstören
                                    von Dingen sowie das Treten nach Gegenständen. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenVier}
                        onChange={this.handleChange}
                        name="VerhaltenVier"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.5 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      3.5 Physisch aggressives Verhalten gegenüber anderen
                      Personen
                    </h4>
                    <Popover
                      content="Physisch aggressives Verhalten gegenüber anderen Personen kann z. B. darin bestehen, nach Personen zu schlagen oder zu treten, andere mit Zähnen oder Fingernägeln zu verletzen, andere zu stoßen oder wegzudrängen oder in Verletzungsversuchen gegenüber anderen Personen mit Gegenständen. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenFünf}
                        onChange={this.handleChange}
                        name="VerhaltenFünf"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhlaten Frage 3.6 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>3.6 Verbale Agression</h4>
                    <Popover
                      content="Verbale Aggression kann sich z. B. in verbalen Beschimpfungen oder in der Bedrohung anderer Personen ausdrücken. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenSechs}
                        onChange={this.handleChange}
                        name="VerhaltenSechs"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.7 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      3.7 Andere pflegerelevante verbale Auffälligkeiten
                    </h4>
                    <Popover
                      content="Andere pflegerelevante vokale Auffälligkeiten können sein: Lautes Rufen, Schreien,
                                    Klagen ohne nachvollziehbaren Grund, vor sich hin schimpfen, fluchen, seltsame
                                    Laute von sich geben, ständiges Wiederholen von Sätzen und Fragen. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenSieben}
                        onChange={this.handleChange}
                        name="VerhaltenSieben"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.8 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      3.8 Abwehr pflegerischer oder anderer unterstützender
                      Maßnahmen
                    </h4>
                    <Popover
                      content="Hier ist die Abwehr von Unterstützung, z. B. bei der Körperpflege, die Verweigerung
                                    der Nahrungsaufnahme, der Medikamenteneinnahme oder anderer notwendiger
                                    Verrichtungen sowie die Manipulation an Vorrichtungen wie z. B. an Kathetern, Infusionen oder Sondenernährung gemeint. Dazu gehört nicht die willentliche
                                    (selbstbestimmte) Ablehnung bestimmter Maßnahmen. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenAcht}
                        onChange={this.handleChange}
                        name="VerhaltenAcht"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.9 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>3.9 Wahnvorstellungen</h4>
                    <Popover
                      content="Wahnvorstellungen beziehen sich z. B. auf die Vorstellung, mit Verstorbenen oder
                                    imaginären Personen in Kontakt zu stehen oder auf die Vorstellung, verfolgt, bedroht oder bestohlen zu werden. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenNeun}
                        onChange={this.handleChange}
                        name="VerhaltenNeun"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.10 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>3.10 Ängste</h4>
                    <Popover
                      content="Die Person hat starke Ängste oder Sorgen, sie erlebt Angstattacken unabhängig von
                                    der Ursache."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenZehn}
                        onChange={this.handleChange}
                        name="VerhaltenZehn"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.11 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      3.11 Antriebslosigkeit bei deppresiever Stimmungslage
                    </h4>
                    <Popover
                      content="Antriebslosigkeit bei depressiver Stimmungslage zeigt sich z. B. daran, dass die Person kaum Interesse an der Umgebung hat, kaum Eigeninitiative aufbringt und Motivierung durch andere benötigt, um etwas zu tun."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenElf}
                        onChange={this.handleChange}
                        name="VerhaltenElf"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.12 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      3.12 Sozial inadäquate Verhaltensweisen
                    </h4>
                    <Popover
                      content="Sozial inadäquate Verhaltensweisen sind z. B. distanzloses Verhalten, auffälliges
                                    Einfordern von Aufmerksamkeit, sich vor anderen in unpassenden Situationen auskleiden, unangemessenes Greifen nach Personen oder unangemessene körperliche
                                    oder verbale sexuelle Annäherungsversuche. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenZwölf}
                        onChange={this.handleChange}
                        name="VerhaltenZwölf"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Verhalten Frage 3.13 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      3.13 Sonstige pflegerelevante inadäquate Handlungen
                    </h4>
                    <Popover
                      content="Sonstige pflegerelevante inadäquate Handlungen sind z. B. Nesteln an der Kleidung,
                                    ständiges Wiederholen der gleichen Handlung (Stereotypien), planlose Aktivitäten,
                                    Verstecken oder Horten von Gegenständen, Kotschmieren, Urinieren in die Wohnung."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VerhaltenDreizehn}
                        onChange={this.handleChange}
                        name="VerhaltenDreizehn"
                      >
                        <MenuItem key={0} value={0}>
                          nie oder selten
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          selten (ein bis dreimal in zwei Wochen)
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          häufig (merhmals wöchentlich, aber nicht täglich)
                        </MenuItem>
                        <MenuItem key={5} value={5}>
                          täglich
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </>
            ) : current === 3 ? (
              <>
                <h2>Selbstversorgung</h2>
                {/*Versorgung Frage 4.1 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.1 Waschen des vorderen Oberkörpers
                    </h4>
                    <Popover
                      content="Sich die Hände, das Gesicht, den Hals, die Arme, die Achselhöhlen und den vorderen Brustbereich waschen und abtrocknen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungEins}
                        onChange={this.handleChange}
                        name="VersorgungEins"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.2 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.2 Körperpflege im Bereich des Kopfes (Kämmen,
                      Zahnpflege, Rasieren)
                    </h4>
                    <Popover
                      content="Kämmen, Zahnpflege, Prothesenreinigung, Rasieren"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungZwei}
                        onChange={this.handleChange}
                        name="VersorgungZwei"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.3 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.3 Waschen des Intimbereichs
                    </h4>
                    <Popover
                      content="Den Intimbereich waschen und abtrocknen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungDrei}
                        onChange={this.handleChange}
                        name="VersorgungDrei"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.4 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.4 Duschen und Baden einschließlich Waschen der Haare
                    </h4>
                    <Popover
                      content="Dabei sind neben der Fähigkeit, den Körper waschen zu können, auch Sicherheitsaspekte zu berücksichtigen. (Teil-) Hilfen beim Waschen in der Wanne, Dusche sind
                                    hier ebenso zu berücksichtigen wie die Hilfe beim Ein- und Aussteigen oder eine
                                    notwendige Überwachung während des Bades. Dazu gehört auch das Abtrocknen,
                                    Haare waschen und föhnen."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungVier}
                        onChange={this.handleChange}
                        name="VersorgungVier"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.5 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.5 An- und Auskleiden des Oberkörpers
                    </h4>
                    <Popover
                      content="Bereitliegende Kleidungsstücke, z. B. Unterhemd, T-Shirt, Hemd, Bluse, Pullover,
                                    Jacke, BH, Schlafanzugoberteil oder Nachthemd, an- und ausziehen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungFünf}
                        onChange={this.handleChange}
                        name="VersorgungFünf"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.6 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.6 An- und Auskleiden des Unterkörpers
                    </h4>
                    <Popover
                      content="Bereitliegende Kleidungsstücke, z. B. Unterwäsche Hose, Rock, Strümpfe und
                                    Schuhe, an- und ausziehen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungSechs}
                        onChange={this.handleChange}
                        name="VersorgungSechs"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.7 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.7 Mundgerechtes Zubereiten der Nahrung und Eingießen von
                      Getränken
                    </h4>
                    <Popover
                      content="Zerteilen von Nahrung in mundgerechte Stücke und Eingießen von Getränken"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungSieben}
                        onChange={this.handleChange}
                        name="VersorgungSieben"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.8 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>4.8 Essen</h4>
                    <Popover
                      content="Dies beinhaltet das Aufnehmen, zum Mund Führen, ggf. Abbeißen, Kauen und
                                    Schlucken von mundgerecht zubereiteten Speisen, die üblicherweise mit den Fingern gegessen werden, z. B. Brot, Kekse, Obst oder das Essen mit Gabel oder Löffel,
                                    ggf. mit speziellen Hilfsmitteln wie adaptiertem Besteck."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungAcht}
                        onChange={this.handleChange}
                        name="VersorgungAcht"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={6} value={6}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={9} value={9}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.9 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>4.9 Trinken</h4>
                    <Popover
                      content="Bereitstehende Getränke aufnehmen, ggf. mit Gegenständen wie Strohhalm, Spezialbecher mit Trinkaufsatz"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungNeun}
                        onChange={this.handleChange}
                        name="VersorgungNeun"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={4} value={4}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={6} value={6}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.10 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.10 Benutzen einer Toilette oder eines Toilettenstuhls
                    </h4>
                    <Popover
                      content="Gehen zur Toilette, Hinsetzen und Aufstehen, Sitzen während der Blasen-oder
                                    Darmentleerung, Intimhygiene und Richten der Kleidung "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungZehn}
                        onChange={this.handleChange}
                        name="VersorgungZehn"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={4} value={4}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={6} value={6}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.11 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.11 Bewältigung der Folgen einer Harninkontinenz und
                      Umgang mit Dauerkatheter und Urostoma
                    </h4>
                    <Popover
                      content="Inkontinenz- und Stomasysteme sachgerecht verwenden, nach Bedarf wechseln
                                    und entsorgen "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungElf}
                        onChange={this.handleChange}
                        name="VersorgungElf"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Versorgung Frage 4.12 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      4.12 Bewältigung der Folgen einer Stuhlinkontinenz und
                      Umgang mit Stoma
                    </h4>
                    <Popover
                      content="Inkontinenz- und Stomasysteme sachgerecht verwenden, nach Bedarf wechseln
                                    und entsorgen  "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={VersorgungZwölf}
                        onChange={this.handleChange}
                        name="VersorgungZwölf"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </>
            ) : current === 4 ? (
              <>
                <h2>
                  Bewältigung von und selbstständiger Umgang mit krankheits-
                  oder therapiebedingten Anforderungen und Belastungen
                </h2>
                {/*Krankheitsumgang Frage 5.1  */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>5.1 Medikation</h4>
                    <Popover
                      content="Orale Medikation, Augen- oder Ohrentropfen, Zäpfchen und Medikamentenpflaster. Das Ausmaß der Hilfestellung kann von einmal wöchentlichem Stellen der Medikamente im Wochendispenser bis zu mehrfach täglicher Einzelgabe differieren. Werden Medikamente verabreicht, ist das Stellen nicht gesondert zu berücksichtigen. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangEins}
                        onChange={this.handleChange}
                        name="UmgangEins"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangEins === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangEinsAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.2 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>5.2 Injektion</h4>
                    <Popover
                      content="Dazu gehören z. B. Insulininjektionen oder auch die Versorgung mit Medikamentenpumpen über einen subkutanen Zugang.  "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangZwei}
                        onChange={this.handleChange}
                        name="UmgangZwei"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangZwei === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangZweiAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.3 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.3 Versorgung intravinöser Zugänge
                    </h4>
                    <Popover
                      content="Hierunter fällt hauptsächlich die Port-Versorgung. Sie ist oft fachpflegerisch erforderlich. In Bezug auf den Umgang mit intravenösen Zugängen ist auch die Kontrolle
                                    zur Vermeidung von Komplikationen wie Verstopfung des Katheters zu berücksichtigen."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangDrei}
                        onChange={this.handleChange}
                        name="UmgangDrei"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangDrei === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangDreiAnzahl")}
                    />
                  </div>
                </div>

                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.4 Absaugen und Sauerstoffgabe
                    </h4>
                    <Popover
                      content="Absaugen kann z. B. bei beatmeten oder tracheotomierten Patienten in sehr unterschiedlicher und wechselnder Häufigkeit notwendig sein. Es ist der durchschnittliche Bedarf anzugeben."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangVier}
                        onChange={this.handleChange}
                        name="UmgangVier"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangVier === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangVierAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.5 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.5 Einreibung sowie Kälte- und Wärmeanwendungen
                    </h4>
                    <Popover
                      content="Hier sind alle externen Anwendungen mit ärztlich angeordneten Salben, Cremes,
                                    Emulsionen etc. abzubilden, außerdem Kälte- und Wärmeanwendungen, die z. B.
                                    bei rheumatischen Erkrankungen angeordnet werden."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangFünf}
                        onChange={this.handleChange}
                        name="UmgangFünf"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangFünf === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangFünfAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.6 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.6 Messung und Deutung von Körperzuständen
                    </h4>
                    <Popover
                      content="Die Aktivität umfasst Messungen wie z. B. Blutdruck, Puls, Blutzucker, Temperatur,
                                    Körpergewicht, Flüssigkeitshaushalt, soweit diese auf ärztliche Anordnung erfolgen."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangSechs}
                        onChange={this.handleChange}
                        name="UmgangSechs"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangSechs === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangSechsAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.7 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.7 körpernahe Hilfsmittel
                    </h4>
                    <Popover
                      content="Hierunter versteht man beispielsweise das An- und Ablegen von Prothesen, kieferorthopädische Apparaturen; Orthesen, Brille, Hörgerät oder Kompressionsstrümpfen (inkl. deren Reinigung)."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangSieben}
                        onChange={this.handleChange}
                        name="UmgangSieben"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangSieben === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangSiebenAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.8 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.8 Verbandswechsel und Wundversorgung
                    </h4>
                    <Popover
                      content="Die Aktivität beinhaltet die Versorgung chronischer Wunden, wie z. B. Ulcus cruris
                                    oder Dekubitus."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangAcht}
                        onChange={this.handleChange}
                        name="UmgangAcht"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangAcht === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangAchtAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.9 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.9 Versorgung mit Stoma
                    </h4>
                    <Popover
                      content="Gemeint ist hier die Pflege künstlicher Körperöffnungen wie Tracheostoma, PEG,
                                    subrapubischer Blasenkatheter, Urostoma, Colo- oder Ileostoma."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangNeun}
                        onChange={this.handleChange}
                        name="UmgangNeun"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangNeun === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangNeunAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.10 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.10 Regelmäßige Einmalkatheterisierung und Nutzung von
                      Abführmethoden
                    </h4>
                    <Popover
                      content="Regelmäßige Einmalkatheterisierungen kommen insbesondere bei neurogenen
                                    Blasenentleerungsstörungen vor. Mit Abführmethoden sind Anwendungen von
                                    Klistier, Einlauf, digitale Ausräumung gemeint. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangZehn}
                        onChange={this.handleChange}
                        name="UmgangZehn"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangZehn === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangZehnAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.11 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.11 Therapiemaßnahmen in häuslicher Umgebung
                    </h4>
                    <Popover
                      content="Bei vielen Erkrankungen werden aus einer Heilmitteltherapie heraus Anweisungen
                                    zu einem Eigenübungsprogramm gegeben, welches dauerhaft und regelmäßig
                                    durchgeführt werden soll, z. B. krankengymnastische Übungen, Atemübungen oder
                                    logopädische Übungen. "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangElf}
                        onChange={this.handleChange}
                        name="UmgangElf"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangElf === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangElfAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.12 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.12 Zeit- und technikintensive Maßnahmen in häuslicher
                      Umgebung
                    </h4>
                    <Popover
                      content="Gemeint sind hier spezielle Therapiemaßnahmen wie Hämodialyse oder Beatmung,
                                    die im häuslichen Umfeld durchgeführt werden können, wenn ständige Überwachung während der Maßnahme durch geschulte Pflegepersonen gewährleistet
                                    wird."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangZwölf}
                        onChange={this.handleChange}
                        name="UmgangZwölf"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          pro Tag
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangZwölf === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangZwölfAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.13 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>5.13 Arztbesuche</h4>
                    <Popover
                      content="Hierunter fallen regelmäßige Besuche bei der niedergelassenen Hausärztin bzw.
                                    beim niedergelassenen Hausarzt oder Fachärztin bzw. Facharzt zu diagnostischen
                                    oder therapeutischen Zwecken."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangDreiZehn}
                        onChange={this.handleChange}
                        name="UmgangDreiZehn"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangDreiZehn === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangDreiZehnAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.14 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.14 Besuch anderer medizinischer oder therapeutischer
                      Einrichtungen (bis zu 3 Stunden)
                    </h4>
                    <Popover
                      content="Hier ist das Aufsuchen anderer Therapeuten, z. B. Physiotherapeuten/Krankengymnasten, Ergotherapeuten, Logopäden, Psychotherapeuten, von Krankenhäusern zur ambulanten Behandlung oder Diagnostik oder anderer Einrichtungen des
                                    Gesundheitswesens zu berücksichtigen."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangVierZehn}
                        onChange={this.handleChange}
                        name="UmgangVierZehn"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangVierZehn === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangVierZehnAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.15 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "60%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.15 Zeitlich ausgedehnte Besuche medizinischer oder
                      therapeutischer Einrichtungen
                    </h4>
                    <Popover
                      content="Bei manchen Erkrankungen kann es notwendig sein, spezialisierte Einrichtungen
                                    aufzusuchen, wodurch erhebliche Fahrtzeiten anfallen können. Auch kann es erforderlich sein, sich zeitaufwändiger diagnostischer oder therapeutischer Maßnahmen
                                    zu unterziehen z. B. onkologische Behandlung oder Dialyse."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangFünfZehn}
                        onChange={this.handleChange}
                        name="UmgangFünfZehn"
                      >
                        <MenuItem key={0} value={0}>
                          Entfällt oder Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          pro Woche
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          pro Monat
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: "10%" }}>
                    <InputNumber
                      min={1}
                      max={10}
                      disabled={UmgangFünfZehn === 0 ? true : false}
                      placeholder="Anzahl eintragen"
                      onChange={this.handleNumber("UmgangFünfZehnAnzahl")}
                    />
                  </div>
                </div>

                {/*Krankheitsumgang Frage 5.16 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      5.16 Einhaltung einer Diät oder anderer krankheits- oder
                      therapiebedingter Verhaltensvorschriften
                    </h4>
                    <Popover
                      content="Bei manchen Erkrankungen werden bestimmte Diäten oder Essvorschriften oder
                                    andere Verhaltensvorschriften von der Ärztin oder vom Arzt angeordnet."
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={UmgangSechsZehn}
                        onChange={this.handleChange}
                        name="UmgangSechsZehn"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </>
            ) : current === 5 ? (
              <>
                <h2>Gestalltung des Alltaglebens und sozialer Kontakte</h2>
                {/*Alltag Frage 6.1 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      6.1 Gestalltung des Tagesablaufs und Anpassung an
                      Veränderung
                    </h4>
                    <Popover
                      content="Den Tagesablauf nach individuellen Gewohnheiten und Vorlieben einteilen und
                                    bewusst gestalten und ggf. an äußere Veränderungen anpassen "
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={AlltagEins}
                        onChange={this.handleChange}
                        name="AlltagEins"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Alltag Frage 6.2 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>6.2 Ruhen und Schlafen</h4>
                    <Popover
                      content="Nach individuellen Gewohnheiten einen Tag-Nacht-Rhythmus einhalten und für
                                    ausreichende Ruhe- und Schlafphasen sorgen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={AlltagZwei}
                        onChange={this.handleChange}
                        name="AlltagZwei"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Alltag Frage 6.3 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>6.3 Sichbeschäftigen</h4>
                    <Popover
                      content="Die verfügbare Zeit nutzen, um Aktivitäten durchzuführen, die den eigenen Vorlieben und Interessen entsprechen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={AlltagDrei}
                        onChange={this.handleChange}
                        name="AlltagDrei"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Alltag Frage 6.4 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      6.4 Vornehmen von in die Zukunft gerichteten Planungen
                    </h4>
                    <Popover
                      content="Längere Zeitabschnitte überschauend über den Tag hinaus planen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={AlltagVier}
                        onChange={this.handleChange}
                        name="AlltagVier"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Alltag Frage 6.5 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      6.5 Interaktionen mit Personen im direkten Kontakt
                    </h4>
                    <Popover
                      content="Im direkten Kontakt mit Angehörigen, Pflegepersonen, Mitbewohnern oder Besuchern umgehen, Kontakt aufnehmen, Personen ansprechen, auf Ansprache reagieren"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={AlltagFünf}
                        onChange={this.handleChange}
                        name="AlltagFünf"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/*Alltag Frage 6.6 */}
                <div
                  style={{
                    background: "#ffffff",
                    borderStyle: "none none solid none",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <h4 style={{ color: "#484848" }}>
                      6.6 Kontaktpflege zu Personen außerhalb des direkten
                      Umfeldes
                    </h4>
                    <Popover
                      content="Bestehende Kontakte zu Freunden, Bekannten, Nachbarn aufrechterhalten, beenden oder zeitweise ablehnen"
                      title="Erklärung"
                      style={{ color: "#484848" }}
                    >
                      <Button type="primary" style={{ color: "#484848" }}>
                        Erklärung
                      </Button>
                    </Popover>
                  </div>
                  <div style={{ width: "30%" }}>
                    <FormControl className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-readonly-label"
                        id="demo-simple-select-readonly"
                        value={AlltagSechs}
                        onChange={this.handleChange}
                        name="AlltagSechs"
                      >
                        <MenuItem key={0} value={0}>
                          Selbstständig
                        </MenuItem>
                        <MenuItem key={1} value={1}>
                          überwiegend Selbstständig
                        </MenuItem>
                        <MenuItem key={2} value={2}>
                          überwiegend Unselbstständig
                        </MenuItem>
                        <MenuItem key={3} value={3}>
                          Unselbstständig
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </>
            ) : current === 6 ? (
              <>
                <TableContainer component={Paper}>
                  <Table
                    className={classes.table}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableCell>Module</TableCell>
                      <TableCell align="right">Mobilität</TableCell>
                      <TableCell align="right">Kognitiv</TableCell>
                      <TableCell align="right">Verhalten</TableCell>
                      <TableCell align="right">Versorgung</TableCell>
                      <TableCell align="right">Umgang</TableCell>
                      <TableCell align="right">Alltag</TableCell>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Punkte
                        </TableCell>
                        <TableCell align="right">
                          {this.state.MobilitätGewichtet}
                        </TableCell>
                        <TableCell align="right">
                          {this.state.KognitivGewichtet}
                        </TableCell>
                        <TableCell align="right">
                          {this.state.VerhaltenGewichtet}
                        </TableCell>
                        <TableCell align="right">
                          {this.state.VersorgungGewichtet}
                        </TableCell>
                        <TableCell align="right">
                          {this.state.UmgangGewichtet}
                        </TableCell>
                        <TableCell align="right">
                          {this.state.AlltagGewichtet}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <div
                  style={{
                    background: "#ffffff",
                    borderWidth: 1,
                    margin: 10,
                    padding: 10,
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <h4>Ermittelter Pflegegrad: {this.state.Pflegegrad}</h4>
                </div>
                <p>
                  Bitte beachten Sie, dass die Berechnung Ihnen lediglich eine
                  erste Orientierung zur Pflegebedürftigkeit und zur Einstufung
                  in einen Pflegegrad bietet und ohne jede Gewähr erfolgt.
                </p>
              </>
            ) : (
              <></>
            )}
            {current === 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <Button onClick={this.next}>Weiter</Button>
              </div>
            ) : current === 5 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Button onClick={this.back}>Zurück</Button>
                <Button onClick={this.submit}>Abschließen</Button>
              </div>
            ) : current === 6 ? (
              <Button onClick={this.back}>Zurück</Button>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Button onClick={this.back}>Zurück</Button>
                <Button onClick={this.next}>Weiter</Button>
              </div>
            )}
          </Grid>
        </Container>
      </div>
    );
  }
}

export default withStyles(classes)(Pflegegradrechner);
